<template>
  <icon-prefix :fa="fa">
    <div class="row">
      <div class="col-4">
        <collapsible v-if="description">
          <template v-slot:default="">
            <slot name="left">
              <h5>{{ left_text }}</h5>
            </slot>
          </template>
          <template v-slot:collapsed-content=""
            ><span>{{ description }}</span></template
          >
        </collapsible>
        <slot v-else name="left">
          <h5>{{ left_text }}</h5>
        </slot>
      </div>
      <div class="col-4 text-center">
        <slot>
          <h5>{{ center_text }}</h5>
        </slot>
      </div>
      <div class="col text-right">
        <slot name="right">
          <h5>{{ right_text }}</h5>
        </slot>
      </div>
    </div>
    <slot name="sub"></slot>
  </icon-prefix>
</template>
<script>
import IconPrefix from './icon-prefix.vue';

export default {
  components: {
    'icon-prefix': IconPrefix
  },

  props: {
    fa: {
      type: String,
      required: false,
      default: null
    },
    left_text: {
      type: String,
      required: false
    },
    center_text: {
      type: String,
      required: false
    },
    right_text: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>
